import {InputAdornment, OutlinedInput} from "@mui/material";
import {t} from "i18next";
import {Field, FormikProps, useFormikContext} from "formik";
import {Clear} from "@mui/icons-material";
import {DimensionsUnit} from "../../../models";

export interface DimensionsInputProps {

    units?: DimensionsUnit[];
    onChange?: any;
}

const formatNumber = ({value, decimalPoints = 2}: {
    value: string,
    decimalPoints?: number
}) => {

    if (value.length === 0) {
        return null;
    }

    let formatted = value
        .replace(/[^0-9.]+/g, '')
        .replace(',', '.')
        .replace(/\.(?=.*\.)/g, '')
        .slice(0, 6)

    const formatedNumber = Number(formatted);

    if (formatedNumber < 0 && formatted.length > 0) {
        return Number(0).toFixed(decimalPoints);
    }
    if (formatedNumber > 47) {
        return Number(47).toFixed(decimalPoints);
    }
    return formatted.toString()
}

export default function DimensionsInputFormik({
                                                  onChange,
                                                  units = [DimensionsUnit.In],
                                              }: DimensionsInputProps) {

    const formik = useFormikContext<any>();

    const handleDimensionOnChange = async (formik: FormikProps<any>) => {
        if (onChange)
            onChange(formik)
    }

    const renderDimensionInput = ({dimension}: { dimension: string }) => {

        return <Field
            name={dimension}
            render={() =>
                <OutlinedInput
                    sx={{width: "100%"}} inputProps={{inputMode: 'numeric'}}
                    placeholder={t(`${dimension}.placeholder`, {
                        dimensionUnit: "in"
                    })}
                    value={formik?.values?.[dimension]}
                    onBlur={() => formik.setFieldTouched("weight", true)}
                    onChange={async (event) => {
                        await formik.setFieldValue(dimension, formatNumber({value: event.target.value}));
                        await formik.setFieldTouched(dimension, true)
                        await handleDimensionOnChange(formik)
                    }}
                    error={!!formik.errors[dimension] && !!formik.touched[dimension]}
                    endAdornment={
                        <InputAdornment position="end">
                            {units?.map((unit) => {
                                return <div
                                    className={`dimension-unit 
                                    ${formik.values.dimensionUnit === unit ? 'selected' : ''} 
                                    ${!!formik.errors.dimensionUnit ? 'error' : ''}`}
                                >
                                    {t(`dimension.${unit.toLowerCase()}`)}
                                </div>
                            })
                            }
                        </InputAdornment>
                    }
                />
            }
        />
    }

    const dimensions = ["length", "width", "height"]

    return <>
        {dimensions.map((dimension, index) => {
            return <>
                {renderDimensionInput({dimension})}
                {dimensions?.length - 1 !== index ?
                    <Clear/> : null}
            </>;
        })}
    </>

}